module.exports = __webpack_public_path__ + "media/images/weather/400_night-28c09674bfa116dcfdccde34418ec41f.png";